const booking = {
  bookingInformation: "予約情報", // translated
  ourCancellationPolicy: "キャンセルポリシー", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "これは、上記のキャンセルポリシーに優先します。", // translated
  thisBookingIsNonNefundable: "この予約は返金不可です", // translated
  paymentTerms: "支払い条件", // translated
  paymentWillBeTakenFromYourDefault: "支払いはデフォルトから引き落とされます", // translated
  paymentMethod: "支払方法", // translated
  afterTheFreeCancellationPeriodIfApplicable: "無料キャンセル期間終了後（該当する場合）", // translated
  prebook: "事前予約", // translated
  guests: "ゲスト", // translated
  payment: "支払い", // translated
  byClicking: "クリックして", // translated
  youAreAgreeingToOur: "あなたは私たちのことに同意します", // translated
  termsAndConditions: "利用規約", // translated
  lastBookableDate: "最終予約可能日", // translated
  customerRemarksTextfield: "お客様の声", // translated
  request: "リクエスト", // translated
  cancellationPolicy: "取り消し規約", // translated
};



export default booking;
